<template>
  <div class="banner-wrapper">
    <a-carousel arrows autoplay>
      <template #prevArrow>
        <div
          class="custom-slick-arrow"
          style="left: calc(50% - 590px); z-index: 1"
        >
          <img src="../../assets/pc/left-circle.png" alt="" />
        </div>
      </template>
      <template #nextArrow>
        <div class="custom-slick-arrow" style="right: calc(50% - 590px)">
          <img src="../../assets/pc/right-circle.png" alt="" />
        </div>
      </template>
      <div class="banner-item" v-for="(item, index) in list" :key="index">
        <div class="banner" @click="handleToUrl(item)">
          <img :src="item.banner" alt="" />
        </div>
      </div>
    </a-carousel>
  </div>
</template>
<script setup>
import { defineProps } from "vue";
import { pcToLink } from "@/utils/help";

defineProps({
  list: Array,
});

const handleToUrl = async (item) => {
  if (item.url) {
    pcToLink(item.url);
  }
};

// const bannerList = [
//   {
//     imageUrlPC: "https://t7.baidu.com/it/u=1956604245,3662848045&fm=193&f=GIF",
//   },
//   {
//     imageUrlPC: "https://t7.baidu.com/it/u=825057118,3516313570&fm=193&f=GIF",
//   },
//   {
//     imageUrlPC: "https://t7.baidu.com/it/u=3908717,2002330211&fm=193&f=GIF",
//   },
// ];
</script>
<style lang="less" scoped>
/* For demo */
.ant-carousel :deep(.slick-slide) {
  text-align: center;
  height: 400px;
}

.ant-carousel :deep(.slick-dots) {
  justify-content: flex-start;
  width: 1180px;
  left: 50%;
  transform: translateX(-50%);
  margin-left: 20px;
  margin-bottom: 64px;
}

.banner-wrapper {
  //   margin-top: -60px;
  .banner-item {
    position: relative;
    width: 100%;
    height: 400px;
    .banner {
      width: 100%;
      height: 400px;
      transition: all linear;
      img {
        transition: width 2s;
        display: block;
        width: 0;
        height: 0;
        min-width: 100%;
        max-width: 100%;
        min-height: 100%;
        max-height: 100%;
        object-fit: cover;
      }
    }
  }
}

:deep(.slick-arrow.custom-slick-arrow) {
  width: 48px;
  height: 48px;
  transition: ease all 0.3s;
  opacity: 0.5;
  z-index: 1;
  img {
    width: 100%;
  }
}
:deep(.slick-arrow.custom-slick-arrow:before) {
  display: none;
}
:deep(.slick-arrow.custom-slick-arrow:hover) {
  opacity: 1;
}
</style>
